/**************************************************************************************************/
/*   File: /src/app/app-routing.module.ts                                                         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'shell',
    pathMatch: 'full'
  },
  {
    path: 'shell',
    loadChildren: './containers/shell/module#ShellModule'
  },

  {
    path: 'delivery',
    loadChildren: './shared/components/delivery/module#DeliveryModule'
  },

  {
    path: '**',
    redirectTo: 'shell'
  }
];

/**
 * The App routing module
 */
@NgModule({
  imports: [RouterModule.forRoot(routes,  { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
